import React from 'react';
import { Link, LinkProps } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const useStyles = makeStyles(() => ({
  caret: {
    position: 'relative',
    top: '8px'
  }
}));

export enum CaretDirection {
  UP, DOWN
}

interface LinkCaretProps extends LinkProps {
  text: string,
  caretDirection?: CaretDirection
  onClick?: () => void
  ariaLabel?: string
  ariaExpanded?: boolean
  ariaHidden?: boolean
  dataTestId?: string
  className?: string
}

const IconDirection = ({ direction }: any) => {
  const classes = useStyles();

  switch (direction) {
    case CaretDirection.DOWN:
      return (<ExpandMoreIcon className={classes.caret} />);
    case CaretDirection.UP:
      return (<ExpandLessIcon className={classes.caret} />);
    default:
      return null;
  }
};

/**
 * @deprecated Use `@noqo/clients/web/shared-components/atoms/AppLink` instead.
 */
const LinkCaret = ({
  text, caretDirection, onClick, tabIndex, ariaLabel = '', ariaExpanded, ariaHidden, dataTestId, className
}: LinkCaretProps) => (
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  <Link
    component="button"
    onClick={onClick}
    tabIndex={tabIndex}
    aria-label={ariaLabel}
    aria-expanded={ariaExpanded}
    data-testid={dataTestId}
    className={className}
    aria-hidden={ariaHidden}
  >
    { text }
    <IconDirection direction={caretDirection} />
  </Link>
);
export default LinkCaret;
